import { Component } from '@angular/core';
import {ConfigIconComponent} from "@icons";
import {RouterLink} from "@angular/router";
import {ButtonComponent} from "@components";

@Component({
  selector: 'wun-home',
  imports: [
    ConfigIconComponent,
    RouterLink,
    ButtonComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

}
